import { Box } from '@chakra-ui/react';
import { EventListItem } from 'model/modules/events/eventList';
import Carousel from 'presentation/components/shared/Carousel/Carousel';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import EventGridItem from './EventGridItem';

interface Props {
  events: EventListItem[];
  size?: 'medium' | 'large';
  title?: string | null;
  maxWidth?: string;
}

const EventGridCarousel: FC<Props> = ({ events, title, size = 'medium', maxWidth = '720px' }) => {
  const itemWidth = size === 'medium' ? 352 : 630;
  const viewportItemsCount = size === 'medium' ? 2 : 1;

  return (
    <>
      {title && <GridHeading>{title}</GridHeading>}
      <Box maxW={maxWidth}>
        <Carousel
          scrollBy={itemWidth}
          itemsCount={events.length}
          viewportItemsCount={viewportItemsCount}
          showControls={events.length > viewportItemsCount}
          scrollType="fixed"
        >
          {events.map((event, index) => (
            <Box
              key={index}
              w={itemWidth}
              minW={itemWidth}
              scrollSnapAlign="start"
              mr={index < events.length - 1 ? '16px' : 0}
            >
              <EventGridItem data={event} height={size === 'medium' ? 250 : 290} />
            </Box>
          ))}
        </Carousel>
      </Box>
    </>
  );
};

export default EventGridCarousel;
